import React from "react";
import Logo from "components/common/Logo";
import BackIcon from "components/common/BackIcon";
import { useHistory } from "react-router-dom";
import * as routePath from "shared/constants/RoutePathConstants";

interface Props {
  children: React.ReactNode;
  description?: string;
}

export default function UserAuthenticationLayout({
  children,
  description,
}: Props): React.ReactElement {
  let history = useHistory();
  const handleBackToHomePageClick = () => {
    history.push(routePath.HOME);
  };

  return (
    <div className={"flex flex-wrap"}>
      <div className={"w-full lg:w-1/4 h-24 lg:h-screen bg-mint flex-col"}>
        <div className="mt-2 lg:mt-14 flex flex-col w-3/4">
          <div className="ml-10">
            <Logo />
          </div>
          {description && <div className="ml-10 mt-8 invisible lg:visible">{description}</div>}
        </div>
        <div className="absolute bottom-12 flex-grow invisible md:visible">
          <div className="ml-10">
            <BackIcon
              text="back to homepage"
              onClick={handleBackToHomePageClick}
            />
          </div>
        </div>
      </div>
      <div
        className={
          "w-full lg:w-3/4 flex justify-center mt-6 lg:mt-0 md:items-center"
        }
      >
        <div className="w-363px">{children}</div>
      </div>
    </div>
  );
}
